import React from 'react';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import InstEducativasRules from '../../support/rules/complementos-concepto/InstEducativasRules';
import nivelEducativoOptions from '../../support/catalogs/complementos-concepto/nivelEducativoOptions';

const ComplementoConceptoInstEducativas = (props) => {

  const rules = InstEducativasRules();

  const validate = (data) => {
    return new Validator(data, rules);
  }

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
      version: '1.0'
    };

    const validator = validate(data);

    props.onChange('instEducativas', {
      data,
      isValid: validator.passes()
    })
  };

  const handleOnCancel = () => {
    props.onCancel('instEducativas');
  };

  const data = props.data || {};

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Instituciones Educativas</strong>
      </div>

      <Row>
        <Col sm md={ 4 }>
          <FormControl type="text"
            label="Nombre del alumno"
            name="nombreAlumno"
            placeholder=""
            help=""
            minLength="1"
            rules={ rules.nombreAlumno }
            value={ data.nombreAlumno }
            onChange={ handleOnChange }
          />
        </Col>

        <Col sm md={ 4 }>
        <FormControl type="text"
            label="CURP"
            name="CURP"
            casing={ 'upper' }
            placeholder=""
            help=""
            minLength="18"
            maxLength="18"
            rules={ rules.CURP }
            value={ data.CURP }
            onChange={ handleOnChange }
          />
        </Col>

        <Col sm md={ 4 }>
          <FormControl
            type="select"
            label="Nivel educativo"
            name="nivelEducativo"
            placeholder=""
            help=""
            rules={ rules.nivelEducativo }
            value={ data.nivelEducativo }
            options={ nivelEducativoOptions }
            onChange={ handleOnChange }
            />
        </Col>

        <Col sm md={ 4 }>
          <FormControl
            type="text"
            label="Clave centro de trabajo"
            name="autRVOE"
            placeholder=""
            help=""
            rules={ rules.autRVOE }
            value={ data.autRVOE }
            onChange={ handleOnChange }
            />
        </Col>

        <Col sm md={ 4 }>
          <FormControl
            type="text"
            label="RFC pago"
            name="rfcPago"
            casing={ 'upper' }
            placeholder=""
            help=""
            minLength="12"
            maxLength="13"
            rules={ rules.rfcPago }
            value={ data.rfcPago }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>

      <Row className="pb-3 text-right">
        <Col>
          <Button variant="secondary"
            className="mr-3"
            onClick={ handleOnCancel }
          >
            Cancelar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ComplementoConceptoInstEducativas;
